module.exports = __webpack_public_path__ + "static/kobold-logo-6be234943611d662906bbed0d2555cfc.png";